import { apiService } from "../services/api.service";

export const kartyTagyController = {
    getZoznamTagov,
    getZoznamTagArtikle,
    copyTableKartyTagyFromSqlCloud
};

function getZoznamTagov(cisloKarty) {
    var url = "api/KartyTagy/GetZoznamTagov";

    if (cisloKarty) url = url + "?cisloKarty=" + cisloKarty;

    return apiService.fetchApiRequest(url);
}

function getZoznamTagArtikle(tag, cisloKarty) {
    var url = "api/KartyTagy/GetZoznamTagArtikle?tag=" + tag;

    if (cisloKarty) url = url + "&cisloKarty=" + cisloKarty;

    return apiService.fetchApiRequest(url);
}

function copyTableKartyTagyFromSqlCloud() {
    return apiService.fetchApiRequest("api/KartyTagy/CopyTableKartyTagyFromSqlCloud");
}



// WEBPACK FOOTER //
// ./src/controllers/kartytagy.controller.js